/** Maximum number of digits in a valid OIB (Croatian personal identification number). */
export const OIB_DIGITS_LIMIT = 11;

export const OIB_REGEX = new RegExp(`^\\d{${OIB_DIGITS_LIMIT}}$`);
export const EMPTY_OR_WHITESPACE_REGEX = /^\s*$/;